import React from 'react';
import { Select, MenuItem, Icon, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { DateRangeOutlined, FolderOutlined } from '@mui/icons-material';
import { useCheckSubscriptionStatus } from "src/utils/Utils.js";

const CalendarSelect = ({ 
    setSelectedCalendar, 
    user, 
    selectedCalendar, 
    calendars, 
    size = 'sm', 
    sx, 
    checkSubscriptionStatus = true 
}) => {
    const theme = useTheme();
    
    const handleCalendarSelect = async (calendar) => {
        setSelectedCalendar(calendar);
    };

    const CalendarOption = ({ calendar, key }) => {
        const subscriptionStatus = useCheckSubscriptionStatus({ user, calendar });
        const subscribed = checkSubscriptionStatus ? subscriptionStatus.subscribed : false;
        
        return (
            <MenuItem key={key} value={calendar._id} disabled={checkSubscriptionStatus && subscribed}>
                {calendar.calendars ? (
                    <FolderOutlined sx={{ fontSize: "1rem", mr: 1 }} />
                ) : (
                    <DateRangeOutlined sx={{ fontSize: "1rem", mr: 1 }} />
                )}
                <Typography
                    data-testid="calendar-details-name"
                    variant="h5"
                >
                    {calendar.name}
                </Typography>
                {checkSubscriptionStatus && subscribed && (
                    <Icon
                        baseClassName="material-symbols-outlined"
                        sx={{ color: `${theme.palette.success.main}`, verticalAlign: "middle", fontSize: "1rem", ml: 1 }}
                    >
                        bookmark_added
                    </Icon>
                )}
            </MenuItem>
        );
    };

    return (
        <Select
            variant="outlined"
            value={selectedCalendar?._id || ""}
            sx={{
                "& .MuiTypography-root": {
                    fontSize: size === "md" ? `${theme.typography.h2.fontSize} !important` : `${theme.typography.h5.fontSize} !important`,
                    fontWeight: 500,
                },
                ".MuiOutlinedInput-notchedOutline": {
                    display: 'none'
                },
                ".MuiSelect-select": {
                    display: 'flex !important',
                    alignItems: 'center !important',
                    padding: "0px",
                },
                ...sx,
            }}
            onChange={(e) =>
                handleCalendarSelect(
                    calendars.find((calendar) => calendar._id === e.target.value)
                )
            }
        >
            {calendars.map((calendar) => (
                CalendarOption({ calendar, key: calendar._id })
            ))}
        </Select>
    );
};

export default CalendarSelect; 